module.exports = __webpack_public_path__ + "dashboard/img/tags.1c967141d30cfe61a82ea5744dedfe88.svg";